import { ExternalLink } from '@uikit/components/ExternalLink';

export const gallery = [
  {
    image: '/launchpad/stories/wisdomise/wisdomise-1.png',
  },
  {
    image: '/launchpad/stories/wisdomise/wisdomise-2.png',
  },
  {
    image: '/launchpad/stories/wisdomise/wisdomise-3.png',
  },
  {
    image: '/launchpad/stories/wisdomise/wisdomise-4.png',
  },
];

export const membershipTiers = [
  {
    id: 'premium-plus',
    item: (
      <span className="font-normal">
        <span className="font-bold">Premium Plus</span> – Up to{' '}
        <span className="font-bold">250 SQRp</span>
      </span>
    ),
  },
  {
    id: 'premium',
    item: (
      <span className="font-normal">
        <span className="font-bold">Premium</span> – Up to{' '}
        <span className="font-bold">200 SQRp</span>
      </span>
    ),
  },
  {
    id: 'plus',
    item: (
      <span className="font-normal">
        <span className="font-bold">Plus</span> – Up to <span className="font-bold">150 SQRp</span>
      </span>
    ),
  },
  {
    id: 'free',
    item: (
      <span className="font-normal">
        <span className="font-bold">Free</span> – Up to <span className="font-bold">100 SQRp</span>
      </span>
    ),
  },
];

export const step1 = [
  {
    id: 'stake-sqr',
    item: (
      <span className="font-normal">
        <b>
          <ExternalLink
            href="https://magicsquare.io/staking"
            className="text-base-text-blue underline"
          >
            Stake SQR
          </ExternalLink>
        </b>{' '}
        to accumulate <span className="font-bold">SQRp Points</span>.
      </span>
    ),
  },
  {
    id: 'deposit-sqrp',
    item: (
      <span className="font-normal">
        Deposit <span className="font-bold">SQRp Points</span> into the Magic Drop on{' '}
        <span className="font-bold">Magic Launchpad</span> between{' '}
        <span className="font-bold">March 17th and March 19th</span>.
      </span>
    ),
  },
  {
    id: 'claim-wsdm',
    item: (
      <span className="font-normal">
        Once the Magic Drop ends, claim WSDM rewards directly from Magic Launchpad on{' '}
        <span className="font-bold">March 20th</span>.
      </span>
    ),
  },
];

export const step2 = [
  {
    id: 'swap-wsdm',
    item: (
      <span className="font-normal">
        Swap <span className="font-bold">at least $100 into WSDM</span> on Magic Swap between{' '}
        <span className="font-bold">March 21st and March 28th</span>.
      </span>
    ),
  },
  {
    id: 'enter-raffle',
    item: (
      <span className="font-normal">
        Once the swap is complete, you must enter the raffle in the{' '}
        <span className="font-bold">
          <ExternalLink
            href="https://magicsquare.io/store/reward-pools"
            className="text-base-text-blue underline"
          >
            Reward Pools.
          </ExternalLink>
        </span>
      </span>
    ),
  },
  {
    id: 'campaign-end',
    item: (
      <span className="font-normal">
        After the campaign ends, 50 winners will be selected at random.
      </span>
    ),
  },
  {
    id: 'winning-rewards',
    item: (
      <span className="font-normal">
        Winning rewards will be airdropped directly to wallets on March 31st.
      </span>
    ),
  },
];
